import { objectBoolToArrayString } from "~/common/helpers/object-bool-to-array-string";
import { objectMergeBool } from "~/common/helpers/object-merge-bool";
import type { GetAllUsersDto } from "~/common/interfaces/dto/users/get-all-users.dto";
import type { Filter } from "~/common/interfaces/filter.interface";

export const serializeUserFilters = (updatedFilters: Filter[]) => {
	const serializedFilters: GetAllUsersDto = {};
	updatedFilters.forEach((filter) => {
		const value = filter.value as Record<string, boolean>;

		if (filter.name === "Roles") {
			serializedFilters.roles = objectBoolToArrayString(value);
		} else {
			const mergedBool = objectMergeBool(value);
			if (mergedBool !== null) {
				serializedFilters.isActive = mergedBool;
			}
		}
	});

	return serializedFilters;
};
